module.exports = __webpack_public_path__ + "static/media/17.1.29873928.png";